export default __webpack_public_path__ + "images/c141aa2b3e454278e5844dfe2137ba66-new_age.webp";